import { Button } from '@akin-home/buttons/native';

interface Props {
  onPress?(): void;
}

export const ScreenBackButton = (props: Props) => (
  <Button
    icon="arrow-left"
    iconSize={25}
    size="large"
    variant="secondary"
    testID="go-back-button"
    {...props}
  />
);
